import { requiredUuidString } from '../zod-helpers/index.js';
import { transferOrderInputShape } from './create-input.js';
export const updateTransferOrderInputSchema = transferOrderInputShape
    .omit({ items: true, brandId: true, fromLocationGroupId: true, ownerIsFrom: true })
    .extend({
    id: requiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
});
//# sourceMappingURL=update-input.js.map